var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { bind } from 'bind-decorator';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import * as route from '@lean-body/src/route';
import { Header, FixedFooter, FIXED_FOOTER_HEIGHT, STICKY_HEADER_ROUTES, } from '@lean-body/components/organisms';
import { Colors, MediaBreakPointUp, Sizes, drawerWidth } from '@lean-body/components/styles';
import { AuthStatus } from '@lean-body/src/interfaces';
import { isiOSApp } from '@lean-body/src/util';
import { useLocation } from 'react-router-dom';
import { useSmMediaQuery, useXlMediaQuery } from '@lean-body/src/util/media_query_hooks';
import { LocalStorage } from '@lean-body/src/infra';
import { RootMain } from './root_main';
import { useToastStore } from '../stores/toast_store';
import { ToastStack } from '../molecules/toast_stack';
import { isTvConnectionBannerVisible } from '../organisms/tv_connection_banner';
let cachedMainPageVM = null;
export const Main = ({ contentFactory, tracker, accountService, announcementService, alertPresenter, apiClient, config, }) => {
    var _a;
    if (!cachedMainPageVM) {
        cachedMainPageVM = new MainPageVM(accountService, announcementService, alertPresenter, apiClient, config);
    }
    const vm = cachedMainPageVM;
    const isSM = useSmMediaQuery();
    const isXl = useXlMediaQuery();
    const location = useLocation();
    const localStorage = new LocalStorage();
    vm.location = location;
    const isHeaderDisplayable = vm.isHeaderDisplayable(isSM);
    const isFixedFooterDisplayable = vm.isFixedFooterDisplayable(isSM);
    const isTopRoute = route.routes.TOP.compile() === location.pathname;
    const isCountLessonPlayerRoute = route.routes.COUNT_LESSON_DETAIL.matchPath(location.pathname);
    const onClickAppstoreBannerHideButton = () => {
        localStorage.saveHideAppstore(true);
    };
    const styles = StyleSheet.create({
        container: Object.assign({ background: Colors.White, overflow: 'visible' }, (isTopRoute && {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100dvh',
            [MediaBreakPointUp.XL]: {
                height: '100dvh',
                minHeight: 0,
                overflow: 'hidden',
            },
        })),
        content: Object.assign({ overflow: 'visible' }, (isTopRoute
            ? {
                paddingTop: 0,
                paddingBottom: isFixedFooterDisplayable && isSM ? FIXED_FOOTER_HEIGHT : 0,
                [MediaBreakPointUp.MD]: {
                    marginLeft: isHeaderDisplayable ? drawerWidth.md : 0,
                },
                [MediaBreakPointUp.XL]: {
                    flex: 1,
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    paddingBottom: 0,
                    marginLeft: isHeaderDisplayable ? drawerWidth.xl : 0,
                },
            }
            : {
                // 再生画面はブラウザバー表示中の高さに収め、親の最低高さでもスクロールを作らない。
                minHeight: isCountLessonPlayerRoute ? '100svh' : '100vh',
                paddingTop: vm.headerHeight(isSM),
                paddingBottom: isFixedFooterDisplayable ? FIXED_FOOTER_HEIGHT : 0,
                [MediaBreakPointUp.MD]: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginLeft: isHeaderDisplayable ? drawerWidth.md : 0,
                    height: '100%',
                    minHeight: isCountLessonPlayerRoute ? '100svh' : '100vh',
                },
                [MediaBreakPointUp.XL]: {
                    marginLeft: isHeaderDisplayable ? drawerWidth.xl : 0,
                },
            })),
    });
    // LIVEイベント時に使ってたフロートのバナー、また使う場合、画像はバナーAPIから取得するようにする
    const [fixedBannerDisplayable, setFixedBannerDisplayable] = React.useState(false);
    const [me, setMe] = React.useState(null);
    const [profile, setProfile] = React.useState(null);
    const isMegalosUser = !!((_a = me === null || me === void 0 ? void 0 : me.payment) === null || _a === void 0 ? void 0 : _a.isMegalosUser);
    const [footer, setFooter] = React.useState(null);
    const [unreadAnnouncementCount, setUnreadAnnouncementCount] = React.useState(null);
    const [currentStreak, setCurrentStreak] = React.useState(null);
    const [isTvBannerVisible, setIsTvBannerVisible] = React.useState(isTvConnectionBannerVisible);
    const onCloseTvBanner = React.useCallback(() => {
        new LocalStorage().setTvConnectionBannerDismissedAt(Date.now());
        setIsTvBannerVisible(false);
    }, []);
    const toasts = useToastStore((state) => state.toasts);
    const hideToast = useToastStore((state) => state.hideToast);
    React.useEffect(() => {
        let isMounted = true;
        const initialize = () => __awaiter(void 0, void 0, void 0, function* () {
            const [fetchedMe, fetchedProfile] = yield Promise.all([
                vm.accountService.fetchMe(),
                vm.apiClient.fetchMypageProfile(),
            ]);
            if (isMounted) {
                setMe(fetchedMe);
                setProfile(fetchedProfile);
            }
            if (vm.isDormant) {
                return;
            }
            const [fetchedFooter, unreadCount] = yield Promise.all([vm.apiClient.fetchFooter(), vm.fetchUnreadAnnouncement()]);
            if (isMounted) {
                setFooter(fetchedFooter);
                setUnreadAnnouncementCount(unreadCount);
            }
        });
        initialize();
        return () => {
            isMounted = false;
        };
    }, []);
    React.useEffect(() => {
        let isMounted = true;
        const fetchStreak = () => __awaiter(void 0, void 0, void 0, function* () {
            if (vm.isDormant || !isTopRoute) {
                return;
            }
            const streak = yield vm.apiClient.fetchCurrentStreak();
            if (isMounted) {
                setCurrentStreak(streak);
            }
        });
        fetchStreak();
        return () => {
            isMounted = false;
        };
    }, [isTopRoute]);
    // HOME の XL（固定シェル）では #homeMapScroll のみスクロール。html/body のスクロールバー用ガターが右端に出ないよう抑止する
    // XL未満はページ全体がスクロールしてツールバーが隠れるようにする
    React.useEffect(() => {
        if (!isTopRoute || !isXl) {
            return;
        }
        const html = document.documentElement;
        const body = document.body;
        const prevHtmlOverflow = html.style.overflow;
        const prevBodyOverflow = body.style.overflow;
        html.style.overflow = 'hidden';
        body.style.overflow = 'hidden';
        return () => {
            html.style.overflow = prevHtmlOverflow;
            body.style.overflow = prevBodyOverflow;
        };
    }, [isTopRoute, isXl]);
    if (!me || !profile)
        return null;
    return (React.createElement("div", { className: css(styles.container) },
        isHeaderDisplayable && (React.createElement(Header, { isMegalosUser: isMegalosUser, unreadAnnouncementCount: unreadAnnouncementCount, footer: footer, isDormant: vm.isDormant, payment: me.payment, accountService: vm.accountService, me: me, setMe: setMe, profile: profile, alertPresenter: vm.alertPresenter, apiClient: vm.apiClient, tracker: tracker, config: vm.config, currentStreak: currentStreak, isTvBannerVisible: isTvBannerVisible, onCloseTvBanner: onCloseTvBanner })),
        React.createElement("div", { className: css(styles.content) },
            React.createElement(RootMain, { cf: contentFactory, profile: profile, setProfile: setProfile, me: me, setMe: setMe, currentStreak: currentStreak, isTvBannerVisible: isTvBannerVisible, onCloseTvBanner: onCloseTvBanner })),
        React.createElement(ToastStack, { toasts: toasts, onClose: hideToast }),
        isFixedFooterDisplayable && (React.createElement(FixedFooter, { footer: footer, config: vm.config, fixedBannerDisplayable: fixedBannerDisplayable, hideFixedBanner: () => setFixedBannerDisplayable(false), onClickAppstoreBannerHideButton: onClickAppstoreBannerHideButton }))));
};
export class MainPageVM {
    constructor(accountService, announcementService, alertPresenter, apiClient, config) {
        Object.defineProperty(this, "accountService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "announcementService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "alertPresenter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "location", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.accountService = accountService;
        this.announcementService = announcementService;
        this.alertPresenter = alertPresenter;
        this.apiClient = apiClient;
        this.config = config;
    }
    fetchUnreadAnnouncement() {
        return this.announcementService.getUnreadAnnounecmentCount();
    }
    get isDormant() {
        return this.accountService.authStatus === AuthStatus.Dormant;
    }
    get isFuture() {
        return this.accountService.authStatus === AuthStatus.Future;
    }
    get isCheckEmailPage() {
        return route.routes.CHECK_EMAIL.matchPath(this.location.pathname);
    }
    get isFutureUserPage() {
        return route.routes.FUTURE_USER.matchPath(this.location.pathname);
    }
    get isGoalMatchingAssessmentPage() {
        return (route.routes.GOAL_MATCHING_ASSESSMENT.matchPath(this.location.pathname) ||
            route.routes.SIGNUP_MATCHING_ASSESSMENT.matchPath(this.location.pathname));
    }
    get isCoachingPage() {
        return route.routes.COACHING.matchPath(this.location.pathname);
    }
    get isCountLessonPage() {
        return (route.routes.COUNT_LESSONS.matchPath(this.location.pathname) ||
            route.routes.COUNT_LESSON_DETAIL.matchPath(this.location.pathname));
    }
    get isMealRecordPage() {
        return route.routes.DAILY_TASKS_SUBTASK.matchPathWithParams(this.location.pathname, {
            taskName: route.DailyTasksPageTaskName.meal,
        });
    }
    get isOriginalPlaylistCreateOrUpdatePage() {
        if (route.routes.NEW_PLAYLIST.matchPath(this.location.pathname))
            return true;
        if (route.routes.ORIGINAL_PLAYLIST_UPDATE.matchPath(this.location.pathname))
            return true;
        return false;
    }
    // ヘッダーの高さ（スマホの固定ヘッダー分。タブレット以上で非表示のときは 0）
    headerHeight(isSM) {
        if (!this.isHeaderDisplayable(isSM) || STICKY_HEADER_ROUTES.includes(this.location.pathname)) {
            return 0;
        }
        if (!isSM) {
            return 0;
        }
        return Sizes.MobileHeaderHeight;
    }
    // ヘッダーを表示するかどうか
    isHeaderDisplayable(isSM) {
        if (this.isCheckEmailPage ||
            this.isFutureUserPage ||
            this.isGoalMatchingAssessmentPage ||
            (isSM && this.isCountLessonPage)) {
            return false;
        }
        if (isiOSApp()) {
            return false;
        }
        return true;
    }
    // 固定フッターを表示するかどうか。
    isFixedFooterDisplayable(isSM) {
        if (!isSM) {
            return false;
        }
        if (this.isDormant) {
            return false;
        }
        if (this.isCheckEmailPage ||
            this.isFutureUserPage ||
            this.isOriginalPlaylistCreateOrUpdatePage ||
            this.isGoalMatchingAssessmentPage ||
            this.isCoachingPage ||
            this.isCountLessonPage ||
            this.isMealRecordPage) {
            return false;
        }
        if (isiOSApp()) {
            return false;
        }
        return true;
    }
}
__decorate([
    bind
], MainPageVM.prototype, "fetchUnreadAnnouncement", null);
